import React from 'react';
import { Box, Text, Heading } from '@razorpay/blade/components';
import { TRIGGER_ICONS } from '../../constants';
import { SelectionCard } from './styles';
import { TriggerSelectionProps } from './types';

const TriggerSelection = ({ triggers, selectedTriggerCode, onSelect }: TriggerSelectionProps) => {
  const getIcon = (code: string) => {
    return TRIGGER_ICONS[code] || '⚡';
  };

  return (
    <Box display="flex" flexDirection="column" gap="spacing.5">
      <Box>
        <Heading size="medium">Choose a starter</Heading>
        <Text size="small" color="surface.text.gray.muted" marginTop="spacing.2">
          This event or schedule will launch your flow
        </Text>
      </Box>

      <Box display="flex" flexDirection="column" gap="spacing.3">
        {triggers.map((trigger) => (
          <SelectionCard
            key={trigger.code}
            isSelected={selectedTriggerCode === trigger.code}
            onClick={() => onSelect(trigger)}>
            <Box display="flex" alignItems="center" gap="spacing.3">
              <Box
                width="spacing.9"
                height="spacing.9"
                borderRadius="medium"
                backgroundColor="surface.background.gray.moderate"
                display="flex"
                alignItems="center"
                justifyContent="center">
                <Text size="large">{getIcon(trigger.code)}</Text>
              </Box>
              <Box>
                <Text weight="semibold">{trigger.name}</Text>
                <Text size="small" color="surface.text.gray.muted">
                  {trigger.description}
                </Text>
              </Box>
            </Box>
          </SelectionCard>
        ))}
      </Box>
    </Box>
  );
};

export { TriggerSelection };
